import { render, staticRenderFns } from "./points.vue?vue&type=template&id=fdc4d0aa&scoped=true&"
import script from "./points.vue?vue&type=script&lang=js&"
export * from "./points.vue?vue&type=script&lang=js&"
import style0 from "./points.vue?vue&type=style&index=0&id=fdc4d0aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc4d0aa",
  null
  
)

export default component.exports